module.exports = __webpack_public_path__ + "img/banner-nft.f76acd9a.png";